import { Pipe, PipeTransform } from '@angular/core';
import * as moment from "moment";

@Pipe({
    name: 'momentFormat'
})
export class MomentFormatPipe implements PipeTransform {

    transform(value: any, format: string): string {
        if (moment.isMoment(value)) {
            if (value["_i"] === '0000-00-00') {
              return "";
            }
            return (<moment.Moment>value).format(format);
        }
        return value
    }

}
